export default __webpack_public_path__ + "static/media/fpb10000.9fec19c7.png";